"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
//INTERNAL LIBRARY BITS
const notification_service_1 = require("./notification.service");
let SizeService = class SizeService {
    constructor(_http, _talk) {
        this._http = _http;
        this._talk = _talk;
        //initializations
        this.sizeURL = '/adsize';
    }
    pull() {
        return this._http.get(this.sizeURL)
            .toPromise()
            .then(response => {
            this.sizes = JSON.parse(response._body).map(s => { return s; });
        })
            .catch(this._talk.handle);
    }
    get() {
        return this.sizes;
    }
    getSizeById(id) {
        for (let s in this.sizes) {
            if (this.sizes[s].id == id) {
                return this.sizes[s];
            }
        }
    }
    getSizeByName(name) {
        let sName = (((JSON.stringify(name)).replace(",", "x")).replace(/\[|]/g, '')).replace('/"/g', '');
        for (let s in this.sizes) {
            if (this.sizes[s].name == sName) {
                return this.sizes[s];
            }
        }
    }
    changeIdsToSizes(sizeArray) {
        for (let s in sizeArray) {
            for (let myS in this.sizes) {
                if (sizeArray[s] == this.sizes[myS].id) {
                    sizeArray[s] = ((this.sizes[myS].name).replace("x", ",")).split(',');
                    for (let a in sizeArray[s]) {
                        sizeArray[s][a] = parseInt(sizeArray[s][a], 10);
                    }
                    break;
                }
            }
        }
        return sizeArray;
    }
    changeSizesToIds(sizeArray) {
        for (let s in sizeArray) {
            let name = (((JSON.stringify(sizeArray[s])).replace(",", "x")).replace(/\[|]/g, '')).replace('/"/g', '');
            for (let myS in this.sizes) {
                if (name == this.sizes[myS].name) {
                    sizeArray[s] = this.sizes[myS].id;
                    break;
                }
            }
        }
        return sizeArray;
    }
};
exports.SizeService = SizeService;
exports.SizeService = SizeService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        notification_service_1.NotificationService])
], SizeService);
//# sourceMappingURL=size.service.js.map